/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import VueRouter, { Route, RouteConfig } from 'vue-router';
import { AUTH_STATE } from '@/config';
import { routeClone } from '@/utils/navigation';

export default [
  {
    path: '/msg',
    name: 'msg',
    meta: { tabbar: 'secret/msg', auth: AUTH_STATE.LOGGED_IN },
    components: {
      static: () => import('@/views/common/static'),
      header: () => import('@/views/common/header'),
      main: () => import('@/views/common/main'),
      footer: () => import('@/views/common/footer'),
    },
    redirect: { name: 'msg_index' },
    children: [
      {
        name: 'msg_index',
        path: '',
        meta: {
          auth: AUTH_STATE.LOGGED_IN,
          title: '消息',
          tabbarAction: (route: Route, router: VueRouter): boolean => {
            if (route.query.autoNav) {
              return false;
            }
            const routeInfo = routeClone(route);
            routeInfo.query.autoNav = 'true';
            router.replace(routeInfo);
            return true;
          },
        },
        component: () => import('@/views/msg/index.vue'),
      },
      {
        name: 'msg_list',
        path: '/user/comments/:type(related|approve|seen|delete|mine|ata|all)',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '消息列表' },
        component: () => import('@/views/msg/list'),
      },
      {
        name: 'msg_sysmsg',
        path: '/msg/sysmsg',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '系统消息' },
        component: () => import('@/views/msg/sysmsg'),
      },
      {
        name: 'msg_talk',
        path: '/msg/talk/:xid',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '聊天' },
        component: () => import('@/views/msg/talk'),
      },
    ],
  },
] as RouteConfig[];
